module.exports = __webpack_public_path__ + "img/banner-mobile.54c57d44.jpg";